// Marca.js — o símbolo da Insigne (o livro aberto do logotipo), em qualquer
// cor. Mesmo componente do site principal (insigne-landing-page, ui/Marca):
// o PNG branco entra como MÁSCARA, e a cor vem de `currentColor` —
// `text-insigne-orange` pinta de laranja, `text-white/5` faz marca-d'água.
import React from "react";
import MarcaPng from "../../assets/imgs/logo (1).png";

export default function Marca({ className = "", titulo }) {
  const mascara = `url("${MarcaPng}")`;
  return (
    <span
      role={titulo ? "img" : undefined}
      aria-label={titulo}
      aria-hidden={titulo ? undefined : true}
      className={"inline-block shrink-0 bg-current " + className}
      style={{
        aspectRatio: "372 / 329",
        WebkitMaskImage: mascara,
        maskImage: mascara,
        WebkitMaskSize: "contain",
        maskSize: "contain",
        WebkitMaskRepeat: "no-repeat",
        maskRepeat: "no-repeat",
        WebkitMaskPosition: "center",
        maskPosition: "center",
      }}
    />
  );
}
